<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <div v-if="selectedAppForConfig.predefinedResponses" class="mt-3" style="height: 100vh">
        <!-- accordion -->
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid #e2e2e2;
            padding-bottom: 1rem;
          "
        >
          <!-- autoreply master switch -->
          <div style="display: flex; align-items: center">
            <vs-switch v-model="selectedAppForConfig.autoReply" color="success" @input="toggleAutoReply" />
            <label class="ml-2 mt-2">Auto Reply</label>
          </div>
        </div>
        <vs-collapse accordion style="padding-bottom: 1rem; overflow: visible">
          <vs-collapse-item v-for="rating in 5" :key="rating" :title="'Star Rating ' + rating" style="margin-top: 0.5rem; margin-bottom: 0.5rem">
            <template #header>
              <span style="display: flex; align-items: center">
                <span v-for="star in rating" :key="star">
                  <img src="@/assets/images/star.png" style="width: 25px; height: 25px; margin-bottom: 0.3rem; margin-right: 0.2rem" />
                </span>
                <span class="ml-2">- {{ getResponsesByRating(rating).length }}/5 responses added.</span>
              </span>
            </template>
            <!-- empty -->
            <div v-if="!getResponsesByRating(rating).length" class="text-muted" style="display: flex; flex-direction: column; align-items: start">
              <label>No responses added yet.</label>
              <vs-button @click="addResponse(rating)" color="primary" class="ml-2" icon="add">Add Response</vs-button>
            </div>
            <!-- inputs for responses -->
            <div v-for="(response, index) in getResponsesByRating(rating)" :key="response._id" class="items-center">
              <div class="flex items-center" style="width: 100%">
                <vs-input v-model="response.response" class="flex-grow" placeholder="Enter your response" :disabled="true" />
                <!-- view button -->
                <vs-button @click="viewResponseDetailed(response.response)" color="primary" class="ml-2 rounded" icon="visibility" />
                <!-- delete button -->
                <vs-button
                  @click="
                    responseToDelete = {
                      responseId: response._id,
                      rating: response.starRating,
                      text: response.response,
                    };
                    showDeleteAlert = true;
                  "
                  color="danger"
                  class="ml-2 rounded"
                  icon="delete"
                />
                <!-- edit button -->
                <vs-button @click="editResponse(response)" color="warning" class="ml-2 rounded" icon="edit" />
                <!-- add button -->
                <vs-button
                  v-if="index === getResponsesByRating(rating).length - 1 && getResponsesByRating(rating).length < 5"
                  @click="addResponse(rating)"
                  color="primary"
                  class="ml-2 rounded"
                  icon="add"
                />
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vs-col>
    <!-- popup for adding response -->
    <vs-popup
      :title="`Add predefined response for star rating: ${responseToAdd.starRating}`"
      v-model="showAlert"
      :active.sync="showAlert"
      @closed="showAlert = false"
      v-if="responseToAdd.starRating"
    >
      <div class="items-center" style="display: flex; flex-direction: column">
        <label class="mr-2" style="font-size: medium">Current responses: {{ getResponsesByRating(responseToAdd.starRating).length }}/5</label>
        <label class="mr-2">Response:</label>
        <vs-textarea v-model="responseToAdd.response" class="flex-grow" placeholder="Enter your response" maxlength="350" :rows="5" />

        <!-- char limit -->
        <label style="text-align: end" class="mt-2">Character limit: {{ responseToAdd.response.length }}/350</label>
        <vs-button @click="postAddResponse(responseToAdd.starRating)" color="primary" class="ml-2" icon="add"> Add Response </vs-button>
      </div>
    </vs-popup>
    <!-- popup for editing response -->
    <vs-popup
      :title="`Edit predefined response`"
      v-model="showEditAlert"
      :active.sync="showEditAlert"
      @closed="showEditAlert = false"
      v-if="responseToEdit.starRating"
    >
      <div class="items-center" style="display: flex; flex-direction: column">
        <label class="mr-2">Response:</label>
        <vs-input v-model="responseToEdit.response" class="flex-grow" placeholder="Enter your response" />
        <vs-button @click="replaceResponse()" color="primary" class="ml-2" icon="save"> Save Response </vs-button>
      </div>
    </vs-popup>
    <!-- popup for deleting response -->
    <vs-popup
      :title="`Delete predefined response`"
      v-model="responseToDelete"
      :active.sync="showDeleteAlert"
      @closed="
        showDeleteAlert = false;
        responseToDelete = {
          responseId: '',
          rating: 0,
          text: '',
        };
      "
      v-if="responseToDelete.responseId"
    >
      <div class="items-center" style="display: flex; flex-direction: column">
        <label class="mr-2">Are you sure you want to delete the following response?</label>
        <label class="mr-2">{{ responseToDelete.text }}</label>
        <label class="mr-2">Star Rating: {{ responseToDelete.rating }}</label>
        <div class="flex items-center" style="width: 100%; justify-content: end">
          <vs-button @click="showDeleteAlert = false" color="primary" class="ml-2" icon="close"> Cancel </vs-button>
          <vs-button @click="removeResponse(responseToDelete.responseId)" color="danger" class="ml-2" icon="delete"> Delete </vs-button>
        </div>
      </div>
    </vs-popup>
    <!-- popup for viewing response -->
    <vs-popup
      :title="`View predefined response`"
      v-model="showViewAlert"
      :active.sync="showViewAlert"
      @closed="
        showViewAlert = false;
        responseToView = {};
      "
      v-if="responseToView"
    >
      <div class="items-center" style="display: flex; flex-direction: column">
        <label>{{ responseToView }}</label>

        <!-- char limit -->
        <label style="text-align: end" class="mt-2">Character limit: {{ responseToView.length }}/350</label>
      </div>
    </vs-popup>
  </vs-row>
</template>
<script>
import api from "@/rest.js";
import { API } from "@/common/constants";

export default {
  name: "PredefinedResponses",
  props: {
    selectedAppForConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAlert: false,
      showEditAlert: false,
      showDeleteAlert: false,
      showViewAlert: false,
      languages: [],
      responseToView: {},
      responseToDelete: {
        responseId: "",
        rating: 0,
        text: "",
      },
      responseToAdd: {
        response: "",
        starRating: 0,
      },
      responseToEdit: {
        id: "",
        response: "",
        starRating: 0,
      },
    };
  },
  methods: {
    getResponsesByRating(starRating) {
      return this.selectedAppForConfig.predefinedResponses.filter((res) => res.starRating === starRating);
    },

    viewResponseDetailed(response) {
      this.responseToView = response;
      this.showViewAlert = true;
    },

    addResponse(rating) {
      this.responseToAdd.starRating = rating;
      this.showAlert = true;
    },

    editResponse(response) {
      this.responseToEdit.id = response._id;
      this.responseToEdit.starRating = response.starRating;
      this.responseToEdit.response = response.response;
      console.log(this.responseToEdit, response);
      this.showEditAlert = true;
    },

    async toggleAutoReply() {
      this.$vs.loading();
      try {
        const res = await api.put(
          `${API.GET_REVIEWS}/autoReply/${this.selectedAppForConfig._id}?packageName=${this.selectedAppForConfig.packageName}`,
          {
            autoReply: this.selectedAppForConfig.autoReply,
          }
        );
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Auto reply updated successfully",
            color: "success",
            position: "top-right",
          });
          this.selectedAppForConfig = res.data;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while updating auto reply",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async postAddResponse(rating) {
      if (this.responseToAdd.response.length === 0) {
        this.$vs.notify({
          title: "Error",
          text: "Response cannot be empty",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      try {
        const res = await api.post(`${API.GET_REVIEWS}/${this.selectedAppForConfig._id}?packageName=${this.selectedAppForConfig.packageName}`, {
          response: this.responseToAdd.response,
          starRating: rating,
        });
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Response added successfully",
            color: "success",
            position: "top-right",
          });
          this.selectedAppForConfig = res.data;
          this.responseToAdd.response = "";
          this.showAlert = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while adding response",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async replaceResponse() {
      this.$vs.loading();
      try {
        const res = await api.put(
          `${API.GET_REVIEWS}/${this.selectedAppForConfig._id}?packageName=${this.selectedAppForConfig.packageName}&responseId=${this.responseToEdit.id}`,
          {
            response: this.responseToEdit.response,
            starRating: this.responseToEdit.starRating,
          }
        );
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Response updated successfully",
            color: "success",
            position: "top-right",
          });
          this.selectedAppForConfig = res.data;
          this.responseToEdit = {
            id: "",
            response: "",
            starRating: 0,
          };
          this.showEditAlert = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while updating response",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async removeResponse(responseId) {
      this.$vs.loading();
      try {
        const res = await api.delete(
          `${API.GET_REVIEWS}/${this.selectedAppForConfig._id}?responseId=${responseId}&packageName=${this.selectedAppForConfig.packageName}`,
          {}
        );

        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Response deleted successfully",
            color: "success",
            position: "top-right",
          });
          this.selectedAppForConfig.predefinedResponses = this.selectedAppForConfig.predefinedResponses.filter((res) => res._id !== responseId);
          this.showDeleteAlert = false;
          this.responseToDelete = {
            responseId: "",
            rating: 0,
            text: "",
          };
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while deleting response",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
}
.flex-grow {
  flex-grow: 1;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
</style>
